import React from "react";

// Global Components
import Headertwo from "../../Global/Headertwo";
import Footer from "../../Global/Footer";
import BackToTop from "../../Global/BackToTop";

// Team Component
import Team from "./Team";

// CSS
import "./team.css";

// Banner Image
import Bgimg from "../../../assets/images/about-hero.png";

const Main = () => {
  return (
    <>

      <Headertwo />

        <div
            className="inner-page-hero"
            style={{ backgroundImage: `url(${Bgimg})` }}
        >
            <div className="container">
                <div className="hero-heading-title">
                    <h2>Our Team</h2>
                </div>
                {/* <ul className="bradcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <Link to="#">Page </Link>
                        </li>
                        <li>
                            <Link to="#">About Us </Link>
                        </li>
                    </ul> */}
            </div>
        </div>

      <Team />


      <Footer />

      <BackToTop />
    </>
  );
};

export default Main;

